// Welche Verknüpfungen kommen hinzu, welche fallen weg?
//
// Die Objekt-Formulare haben ihre Eigentümerliste früher per „alles löschen, alles neu
// anlegen" gespeichert. Das ist gegenüber einer Quelle mit Verträgen und Triggern
// destruktiv: bestehende Verknüpfungen verlieren dabei ihr `vertrag_ab`, und jeder
// Speichervorgang löst Trigger für unveränderte Zeilen aus. Deshalb der Umweg über die
// Differenz — nur was sich wirklich ändert, wird geschrieben.
export function mengenDifferenz(vorher: string[], nachher: string[]): { hinzu: string[]; weg: string[] } {
  const alt = new Set(vorher);
  const neu = new Set(nachher);
  return {
    hinzu: [...neu].filter((x) => !alt.has(x)),
    weg: [...alt].filter((x) => !neu.has(x)),
  };
}
